import React, { useId } from 'react'
import lockupSvg from '../../brand/xosa-origin-lockup.svg?raw'
import markSvg from '../../brand/xosa-origin-mark.svg?raw'

/**
 * Inline one of the generated brand SVGs. Its mask and clip ids are made
 * unique per instance, so several logos can share a page.
 */
const BrandSvg: React.FC<{ raw: string; className: string }> = ({ raw, className }) => {
  const prefix = `xo${useId().replace(/[^a-zA-Z0-9]/g, '')}`
  const html = raw
    .replace(/<!--[\s\S]*?-->\s*/, '')
    .replace(/xo-/g, `${prefix}-`)
    .replace('<svg ', `<svg class="${className}" aria-hidden="true" focusable="false" `)
  return <span className="inline-flex" dangerouslySetInnerHTML={{ __html: html }} />
}

/** The O-mark alone: favicon, avatars, and the app bar on phones. */
export const XosaOriginMark: React.FC<{ className?: string }> = ({ className = 'h-[26px] w-auto' }) => (
  <BrandSvg raw={markSvg} className={className} />
)

/**
 * App-bar logo in the Xosa format (»Stempel + Snit«): XOSA knocked out of
 * the stamp, ORIGIN as the open word, one cut through both. Phones get the
 * O-mark alone. Drawn in `currentColor`; the parent link carries the name.
 */
const XosaWordmark: React.FC<{ className?: string }> = ({ className = 'inline-flex items-center text-ink' }) => (
  <span className={className}>
    <XosaOriginMark className="h-[26px] w-auto sm:hidden" />
    <BrandSvg raw={lockupSvg} className="hidden h-[21px] w-auto sm:block" />
  </span>
)

export default XosaWordmark
